import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ImgLoaderComponent } from './img-loader/img-loader.component';
import { LightBoxImgComponent } from '../visit-details/dialogs/light-box-img/light-box-img.component';
import { MatIconModule } from '@angular/material/icon';
import { SplitStringToArEnPipe } from './Pipes/splitWordsArEnPipe';
import { CustomSplitPipe } from './Pipes/splitWordsAboutArEn';
import { StarPipe } from './Pipes/starsPipe';
import { CaptchaDialogComponent } from '../register/captcha-dialog/captcha-dialog.component';



@NgModule({
  declarations: [
    ImgLoaderComponent,
    LightBoxImgComponent,
    SplitStringToArEnPipe,
    CustomSplitPipe,
    StarPipe,
    CaptchaDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatIconModule
  ],
  exports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ReactiveFormsModule,
    ImgLoaderComponent,
    LightBoxImgComponent,
    SplitStringToArEnPipe,
    CaptchaDialogComponent,
    CustomSplitPipe,
    StarPipe
  ]
})
export class SharedModule { }

